<dx-data-grid
  *ngIf="vehicleService"
  height="100%"
  width="auto"
  [dataSource]="vehicleService.requests"
  [remoteOperations]="false"
  (onRowInserting)="onRequestInserting($event)"
  (onRowUpdating)="onRequestUpdating($event)"
  (onRowRemoving)="onRequestRemoving($event)">
  <!-- Settings -->
  <dxo-editing mode="row" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"></dxo-editing>
  <dxo-export [enabled]="true" fileName="requests-export"></dxo-export>

  <!-- Columns -->
  <dxi-column caption="Priority" dataField="priority" dataType="string" [allowEditing]="true">
    <dxo-lookup [dataSource]="helperService.requestPriorities" displayExpr="name" valueExpr="id"></dxo-lookup>
    <dxi-validation-rule type="required" message="Priority is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column caption="Requires Service" dataField="requiresService" dataType="boolean" [allowEditing]="true">
  </dxi-column>
  <dxi-column caption="Allow Operation" dataField="allowOperation" dataType="boolean" [allowEditing]="true">
  </dxi-column>
  <dxi-column caption="Comment" dataField="comment" dataType="string" [allowEditing]="true">
    <dxi-validation-rule type="required" message="Comment is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    caption="Created At"
    dataField="createdAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"></dxi-column>
  <dxi-column caption="Created By" dataField="createdBy.username" [allowEditing]="false"></dxi-column>
  <dxi-column
    caption="Resolved At"
    dataField="resolvedAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"
    cellTemplate="resolvedAt_cell">
  </dxi-column>
  <!-- Templates -->
  <ng-container *dxTemplate="let cellInfo of 'resolvedAt_cell'">
    <span *ngIf="!cellInfo.data.id || cellInfo.data.resolvedAt; else resolveButton">{{
      cellInfo.data.resolvedAt | date: 'short'
    }}</span>
    <ng-template #resolveButton>
      <a class="show-loop-link" (click)="resolveRequest(cellInfo.data)" title="link"> Resolve</a>
    </ng-template>
  </ng-container>
</dx-data-grid>
